export const SEND_CHAT_MESSAGE_INIT = "SEND_CHAT_MESSAGE_INIT";
export const SEND_CHAT_MESSAGE_SUCCESS = "SEND_CHAT_MESSAGE_SUCCESS";
export const SEND_CHAT_MESSAGE_FAILED = "SEND_CHAT_MESSAGE_FAILED";

export const GET_CONVERSATIONS_INIT = "GET_CONVERSATIONS_INIT";
export const GET_CONVERSATIONS_SUCCESS = "GET_CONVERSATIONS_SUCCESS";
export const GET_CONVERSATIONS_FAILED = "GET_CONVERSATIONS_FAILED";

export const GET_CONVERSATION_INIT = "GET_CONVERSATION_INIT";
export const GET_CONVERSATION_SUCCESS = "GET_CONVERSATION_SUCCESS";
export const GET_CONVERSATION_FAILED = "GET_CONVERSATION_FAILED";

export const DELETE_CONVERSATION_INIT = "DELETE_CONVERSATION_INIT";
export const DELETE_CONVERSATION_SUCCESS = "DELETE_CONVERSATION_SUCCESS";
export const DELETE_CONVERSATION_FAILED = "DELETE_CONVERSATION_FAILED";

export const RENAME_CONVERSATION_INIT = "RENAME_CONVERSATION_INIT";
export const RENAME_CONVERSATION_SUCCESS = "RENAME_CONVERSATION_SUCCESS";
export const RENAME_CONVERSATION_FAILED = "RENAME_CONVERSATION_FAILED";

export const SET_ACTIVE_CONVERSATION = "SET_ACTIVE_CONVERSATION";
export const CLEAR_CHAT = "CLEAR_CHAT";
export const ADD_USER_MESSAGE = "ADD_USER_MESSAGE";

export const SUBMIT_FEEDBACK_INIT = "SUBMIT_FEEDBACK_INIT";
export const SUBMIT_FEEDBACK_SUCCESS = "SUBMIT_FEEDBACK_SUCCESS";
export const SUBMIT_FEEDBACK_FAILED = "SUBMIT_FEEDBACK_FAILED";
